module.exports = __webpack_public_path__ + "img/esign.94ce8e3c.png";